import React from 'react';
import AdminDataTable from './AdminDataTable';

/**
 * Configuration pour l'administration des tags de manuscrits
 */
const manuscriptTagsConfig = {
  entityName: 'tags',
  apiEndpoint: '/api/config/tool/manuscript-tags',
  exportFileName: 'manuscript-tags',
  
  translations: {
    title: 'MANUSCRIPT_TAGS_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { key: 'tag_key', label: 'Clé', labelKey: 'TABLE_TAG_KEY' },
    { key: 'ui_language', label: 'Langue', labelKey: 'TABLE_UI_LANGUAGE' },
    { key: 'label', label: 'Libellé', labelKey: 'TABLE_LABEL' },
    { key: 'tab_name', label: 'Onglet', labelKey: 'TABLE_TAB_NAME' },
    { key: 'tag_type', label: 'Type', labelKey: 'TABLE_TAG_TYPE' },
    { 
      key: 'is_active', 
      label: 'Actif', 
      labelKey: 'TABLE_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  formFields: [
    {
      name: 'tag_key',
      label: 'Clé du tag',
      labelKey: 'MANUSCRIPT_TAG_KEY',
      type: 'text',
      required: true,
      placeholder: 'ex: summary, keywords...'
    },
    {
      name: 'ui_language',
      label: 'Langue de l\'interface',
      labelKey: 'MANUSCRIPT_TAG_UI_LANGUAGE',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'ui_language'
    },
    {
      name: 'label',
      label: 'Libellé',
      labelKey: 'MANUSCRIPT_TAG_LABEL',
      type: 'text',
      required: true,
      placeholder: 'Libellé affiché dans l\'interface'
    },
    {
      name: 'tab_name',
      label: 'Nom de l\'onglet',
      labelKey: 'MANUSCRIPT_TAG_TAB_NAME',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'tab_name'
    },
    {
      name: 'tag_type',
      label: 'Type de tag',
      labelKey: 'MANUSCRIPT_TAG_TYPE',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'tag_type'
    },
    {
      name: 'is_meta',
      label: 'Est une métadonnée',
      labelKey: 'MANUSCRIPT_TAG_IS_META',
      type: 'checkbox'
    },
    {
      name: 'meta_order',
      label: 'Ordre d\'affichage',
      labelKey: 'MANUSCRIPT_TAG_META_ORDER',
      type: 'number',
      min: 0,
      max: 999,
      placeholder: 'Ordre d\'affichage (optionnel)'
    },
    {
      name: 'is_active',
      label: 'Actif',
      labelKey: 'MANUSCRIPT_TAG_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  filters: [
    {
      name: 'tag_key',
      label: 'Clé du tag',
      labelKey: 'FILTER_TAG_KEY',
      type: 'text',
      placeholder: 'Recherche par clé...'
    },
    {
      name: 'ui_language',
      label: 'Langue',
      labelKey: 'FILTER_UI_LANGUAGE',
      type: 'dynamic-select',
      dynamicSource: 'ui_language'
    },
    {
      name: 'tab_name',
      label: 'Onglet',
      labelKey: 'FILTER_TAB_NAME',
      type: 'dynamic-select',
      dynamicSource: 'tab_name'
    },
    {
      name: 'tag_type',
      label: 'Type',
      labelKey: 'FILTER_TAG_TYPE',
      type: 'dynamic-select',
      dynamicSource: 'tag_type'
    },
    {
      name: 'is_active',
      label: 'Statut',
      labelKey: 'FILTER_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  defaultFormData: {
    tag_key: '',
    ui_language: 'FR',
    label: '',
    tab_name: 'Article',
    tag_type: 'function',
    is_meta: false,
    meta_order: null,
    is_active: true
  }
};

/**
 * Composant d'administration des tags de manuscrits
 */
export default function AdminManuscriptTagsTab() {
  return (
    <AdminDataTable {...manuscriptTagsConfig} />
  );
}
